import React, { useState } from 'react';
import { useTemplate } from '../../../../features/template/TemplateProvider';
import useApi from '../../../../hook/useApi';
import { ButtonCancel, ButtonPrimary } from '../../../../utils/Button';
import countryAr from '../../../../utils/country.json';
import FocusControl from '../../../../utils/FocusControl';
import InputField, {
    InputCheckbox,
    InputPassword,
    SelectOption,
    TextareaField,
    addOption
} from '../../../../utils/InputField';

function ModalCreateAgencyCustomer({ onReload }) {
    const [isError, setIsError] = useState('');
    const { setMessage, closeModal, modalData } = useTemplate();
    console.log(modalData);
    const [loading, setLoading] = useState(false);
    const { post } = useApi();
    // const { initInfo } = useInit();
    const [formData, setFormData] = useState({
        AgencyId: modalData?.id || 0,
        FirstName: '',
        LastName: '',
        AgencyName: modalData?.organization,
        Organization: '',
        OrganizationIcon: '',
        ShortName: '',
        ShortCode: '',
        Email: '',
        Phone: '',
        Address: '',
        Country: '',
        State: '',
        City: '',
        Zip: '',
        Password: '',
        IsBillToAgency: true
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        if (name) {
            setFormData((d) => ({ ...d, [name]: value }));
        }
    };
    const handleCreateCustomer = (e) => {
        setLoading(true);
        e.preventDefault();
        post(`/api/agency/${formData.AgencyId}/customer`, formData)
            .then(({ message, error, referenceName }) => {
                if (error) {
                    setIsError(referenceName);
                    throw new Error(message);
                }
                setMessage({ type: 'success', text: message });
                onReload();
                closeModal();
            })
            .catch((error) => {
                setMessage({ type: 'error', text: error?.message });
            })
            .finally(() => {
                setLoading(false);
            });
    };

    // Focus Control on Error
    FocusControl(isError, setIsError, formData);

    return (
        <form
            onSubmit={handleCreateCustomer}
            encType="multipart/form-data"
            className="flex flex-col gap-4"
        >
            <InputField
                label="Agency Name"
                name="AgencyName"
                placeholder='e.g. "Google"'
                formData={formData}
                onChange={handleChange}
                readOnly
            />
            <InputField
                label="Organization"
                name="Organization"
                placeholder='e.g. "Google"'
                formData={formData}
                onChange={handleChange}
                required
            />
            <div className="flex flex-col sm:flex-row justify-between items-center gap-4">
                <InputField
                    label="First Name"
                    name="FirstName"
                    placeholder='e.g. "John"'
                    formData={formData}
                    onChange={handleChange}
                    required={!formData.IsBillToAgency}
                />
                <InputField
                    label="Last Name"
                    name="LastName"
                    placeholder='e.g. "Smith"'
                    formData={formData}
                    onChange={handleChange}
                    required={!formData.IsBillToAgency}
                />
            </div>

            <div className="flex flex-col sm:flex-row  justify-between items-center gap-4">
                <InputField
                    label="Email Address"
                    name="Email"
                    placeholder='e.g. mail@example.com"'
                    formData={formData}
                    onChange={handleChange}
                    required={!formData.IsBillToAgency}
                />
                <InputField
                    label="Phone Number"
                    name="Phone"
                    placeholder='e.g. "+1 541 754 3010"'
                    formData={formData}
                    onChange={handleChange}
                    required={!formData.IsBillToAgency}
                />
            </div>
            <div className="flex flex-col sm:flex-row  justify-between items-center gap-4">
                <InputField
                    label="Short Name"
                    name="ShortName"
                    placeholder='e.g. "John S."'
                    formData={formData}
                    onChange={handleChange}
                    // required={!formData.IsBillToAgency}
                />
                <InputField
                    label="Short Code"
                    name="ShortCode"
                    placeholder='e.g. "JS"'
                    formData={formData}
                    onChange={handleChange}
                    // required={!formData.IsBillToAgency}
                />
            </div>
            <TextareaField
                label="Address"
                name="Address"
                placeholder='e.g. "1234 Main St"'
                formData={formData}
                onChange={handleChange}
                className="h-16"
                required={!formData.IsBillToAgency}
            />
            <div className=" flex flex-row gap-x-4">
                <SelectOption
                    label="Country"
                    name="Country"
                    formData={formData}
                    onChange={handleChange}
                    options={countryAr?.map(({ name, code }) => addOption(code, name, code))}
                    required={!formData.IsBillToAgency}
                />
                <InputField
                    label="Province/State"
                    name="State"
                    placeholder='e.g. "California"'
                    formData={formData}
                    onChange={handleChange}
                    required={!formData.IsBillToAgency}
                />
            </div>
            <div className="h-16 flex flex-row gap-x-4">
                <InputField
                    label="City"
                    name="City"
                    placeholder='e.g. "San Francisco"'
                    formData={formData}
                    onChange={handleChange}
                    required={!formData.IsBillToAgency}
                />
                <InputField
                    label="ZIP"
                    name="Zip"
                    placeholder='e.g. "94107"'
                    formData={formData}
                    onChange={handleChange}
                    required={!formData.IsBillToAgency}
                />
            </div>
            <InputPassword
                label="Default Password"
                name="Password"
                placeholder="Enter your password"
                formData={formData}
                onChange={handleChange}
                passGenerate
                required={!formData.IsBillToAgency}
            />
            <p className="text-sm text-error/90 font-normal leading-6 ">
                Password must contain at least 1 Letter, 1 Number & 1 Symbol. Minimum length is 8
                characters.
            </p>
            <InputCheckbox
                label="Bill To Agency"
                name="IsBillToAgency"
                formData={formData}
                onChange={(e) =>
                    setFormData((prev) => ({ ...prev, IsBillToAgency: e.target.checked }))
                }
                text="Bill to agency?"
            />
            <div className="w-full flex justify-end items-center gap-2 mb-2">
                <ButtonCancel title="Cancel" onClick={() => closeModal()} />
                <ButtonPrimary title="Create" btnType="submit" loading={loading} />
            </div>
        </form>
    );
}

export default ModalCreateAgencyCustomer;
